import { makeChartComp } from '../../util/makeChartComp';
var BoxChart = makeChartComp('Box');
export default BoxChart;
